<script setup lang="ts">
export interface TcLayoutProps {
  fullHeight?: boolean;
}

const props = defineProps<TcLayoutProps>();
</script>

<template>
  <div class="layout" :class="{ 'layout--full-height': props.fullHeight === true }">
    <slot />
  </div>
</template>

<style scoped lang="scss">
.layout {
  z-index: 1000;
  position: relative;
  display: flex;
  flex: 1 1 auto;
  overflow-x: hidden;

  &--full-height {
    height: 100%;
  }
}
</style>
